module.exports = __webpack_public_path__ + "static/media/Michelle Dauchy Headshot.cf02cd20.jpeg";